module.exports = __webpack_public_path__ + "img/empty.891aa2e8.png";